export type WaveformPreviewAction = 'open_config' | 'seek'

export function getWaveformPreviewAction(options: {
  hasAudio: boolean
  selected: boolean
}): WaveformPreviewAction {
  const { hasAudio, selected } = options
  if (!hasAudio || !selected) {
    return 'open_config'
  }
  return 'seek'
}

export function sortAudioVariantsNewestFirst<T extends { index: number }>(variants: T[]): T[] {
  return [...variants].sort((a, b) => b.index - a.index)
}
